import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';
import global from '../../../common/utility/global';

import CustomTable from '../../../components/CustomTable';

const REGISTRADO = 1;
const ANULADO = 2;
const EMITIDO = 4;
const RECHAZADO = 5;

export default function ResultList(props) {
    const renderColor = (item) => {
        if (item.idGuiaRemisionEstado === REGISTRADO)
            return 'blue';
        if (item.idGuiaRemisionEstado === EMITIDO)
            return 'green';
        if (item.idGuiaRemisionEstado === RECHAZADO)
            return 'orange';
        if (item.idGuiaRemisionEstado === ANULADO)
            return 'red';
    };

    return (
        <CustomTable
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.rowNumber}
            columns={[
        
                {
                    title: 'Serie',
                    dataIndex: 'serie',
                    key: 'serie',
                    sorter: true
                },
                {
                    title: 'Documento',
                    dataIndex: 'documento',
                    key: 'documento',
                    sorter: true
                },
                {
                    title: 'Fecha',
                    dataIndex: 'fechaStr',
                    key: 'fechaStr',
                    sorter: true
                },
                {
                    title: 'Fecha Traslado',
                    dataIndex: 'fechaTrasladoStr',
                    key: 'fechaTrasladoStr',
                    sorter: true
                },

                {
                    title: 'Tipo Documento',
                    dataIndex: 'tipoDocumentoEntidad',
                    key: 'tipoDocumentoEntidad',
                    sorter: true
                },
                {
                    title: 'Número de Documento',
                    dataIndex: 'numeroDocumento',
                    key: 'numeroDocumento',
                    sorter: true
                },
                {
                    title: 'Entidad',
                    dataIndex: 'razonSocial',
                    key: 'razonSocial',
                    sorter: true,
                    render: (value) => (
                        <div style={{ minWidth: "150px" }}>{value}</div>
                    )
                },
                {
                    title: 'Documento Referencia',
                    dataIndex: 'referencia',
                    key: 'referencia',
                    sorter: true
                },
                {
                    title: 'Proyecto',
                    dataIndex: 'proyecto',
                    key: 'proyecto',
                    sorter: true
                },
                {
                    title: 'Motivo',
                    dataIndex: 'motivo',
                    key: 'motivo',
                    sorter: true
                },
                {
                    title: 'Tipo Traslado',
                    dataIndex: 'modalidad',
                    key: 'modalidad',
                    sorter: true
                },
                {
                    title: 'Total Peso',
                    dataIndex: 'totalPeso',
                    key: 'totalPeso',
                    sorter: true,
                    render: (value) => (
                        <span>{global.decimalFormat(value.toFixed(2))}</span>
                    )
                },
                {
                    title: 'Estado',
                    dataIndex: 'nombreGuiaRemisionEstado',
                    key: 'nombreGuiaRemisionEstado',
                    align: 'center',
                    width: "90px",
                    fixed: 'right',
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            <Tag color={renderColor(row)}>{value}</Tag>
                        </div>)
                    }
                }
            ]}
        />
    );

}
